<template>
<div v-if="modalz" class="zoom-modal-backdrop" @click.self="cerrarModal">
  <div class="zoom-modal-dialog">
    <div class="zoom-modal-content bg-white shadow-lg rounded-premium overflow-hidden position-relative">
      
      <!-- Header -->
      <div class="zoom-header d-flex justify-content-between align-items-center px-4 py-3 brand-purple-bg text-white">
        <h5 class="m-0 font-weight-bold text-white d-flex align-items-center gap-2" style="font-size: 1.15rem;">
          <i class="fa fa-search-plus"></i> {{ producto.nombre || 'Vista Ampliada' }}
        </h5>
        <button type="button" class="close-zoom-btn" @click="cerrarModal">×</button>
      </div>

      <!-- Body -->
      <div class="zoom-body p-3 p-md-4 bg-light text-center position-relative">
        
        <!-- Main Image Container with Magnifying Glass Lens Effect -->
        <div class="zoom-main-container d-flex align-items-center justify-content-center position-relative overflow-hidden rounded bg-white border"
             style="min-height: 420px; height: 68vh; max-height: 620px;"
             @mousemove="handleMouseMove"
             @mouseenter="handleMouseEnter"
             @mouseleave="handleMouseLeave">

          <img v-if="imagenes && imagenes.length > 0" 
               :src="`${dominio}/img/productos/${imagenes[selectedIdx || 0].nombre}`" 
               class="main-zoom-img" 
               :style="imgZoomStyle"
               alt="Vista ampliada" />

          <!-- Magnifier Lens Cursor Hint Badge -->
          <div v-if="!isZoomed" class="zoom-hint-badge position-absolute rounded-pill px-3 py-1 text-white shadow-sm pointer-events-none">
            <i class="fa fa-search-plus me-1"></i> Pasa el mouse para ampliar detalle
          </div>
        </div>

        <!-- Navigation Arrows if > 1 image -->
        <template v-if="imagenes && imagenes.length > 1">
          <button type="button" class="zoom-arrow zoom-arrow-left" @click="prevImage" title="Imagen anterior">
            <i class="fa fa-chevron-left"></i>
          </button>
          <button type="button" class="zoom-arrow zoom-arrow-right" @click="nextImage" title="Imagen siguiente">
            <i class="fa fa-chevron-right"></i>
          </button>
        </template>

        <!-- Thumbnails gallery if > 1 image -->
        <div v-if="imagenes && imagenes.length > 1" class="zoom-thumbs-row d-flex gap-2 justify-content-center mt-3 overflow-auto">
          <div v-for="(img, idx) in imagenes" :key="idx" 
               class="zoom-thumb-item rounded"
               :class="{'selected-thumb': (selectedIdx || 0) === idx}"
               @click="selectThumb(idx)">
            <img :src="`${dominio}/img/productos/${img.nombre}`" class="img-fluid" />
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ZoomImagen',
  props: {
    modalz: { type: [Boolean, Number], default: false },
    imagenes: { type: Array, default: () => [] },
    producto: { type: Object, default: () => ({}) },
    scroll: { type: Number, default: 0 }
  },
  data() {
    return {
      selectedIdx: 0,
      isZoomed: false,
      zoomX: 50,
      zoomY: 50
    }
  },
  watch: {
    modalz(newVal) {
      if (newVal) {
        this.selectedIdx = 0;
        this.resetZoom();
      }
    }
  },
  computed: {
    ...mapState(['dominio']),
    imgZoomStyle() {
      if (this.isZoomed) {
        return {
          transformOrigin: `${this.zoomX}% ${this.zoomY}%`,
          transform: 'scale(2.6)',
          cursor: 'zoom-out'
        }
      }
      return {
        transformOrigin: 'center center',
        transform: 'scale(1)',
        cursor: 'zoom-in'
      }
    }
  },
  methods: {
    cerrarModal() {
      this.$emit('cerrarModalz', 0);
    },
    resetZoom() {
      this.isZoomed = false;
      this.zoomX = 50;
      this.zoomY = 50;
    },
    selectThumb(idx) {
      this.selectedIdx = idx;
      this.resetZoom();
    },
    nextImage() {
      if (this.imagenes && this.imagenes.length > 0) {
        this.selectedIdx = (this.selectedIdx + 1) % this.imagenes.length;
        this.resetZoom();
      }
    },
    prevImage() {
      if (this.imagenes && this.imagenes.length > 0) {
        this.selectedIdx = (this.selectedIdx - 1 + this.imagenes.length) % this.imagenes.length;
        this.resetZoom();
      }
    },
    handleMouseEnter() {
      this.isZoomed = true;
    },
    handleMouseLeave() {
      this.resetZoom();
    },
    handleMouseMove(e) {
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      this.zoomX = Math.max(0, Math.min(100, x));
      this.zoomY = Math.max(0, Math.min(100, y));
    }
  }
}
</script>

<style scoped>
.zoom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.88);
  backdrop-filter: blur(8px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}

.zoom-modal-dialog {
  width: 100%;
  max-width: 1100px;
  margin: auto;
}

.brand-purple-bg {
  background-color: #713083 !important;
}

.close-zoom-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 2.2rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.9;
  transition: transform 0.2s;
}
.close-zoom-btn:hover {
  transform: scale(1.2);
  opacity: 1;
}

.zoom-main-container {
  box-shadow: inset 0 0 10px rgba(0,0,0,0.05);
}

.main-zoom-img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.12s ease-out;
  will-change: transform, transform-origin;
}

.zoom-hint-badge {
  bottom: 20px;
  background: rgba(113, 48, 131, 0.85);
  font-size: 0.85rem;
  letter-spacing: 0.3px;
  backdrop-filter: blur(4px);
  pointer-events: none;
  z-index: 5;
}

.zoom-arrow {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(113, 48, 131, 0.88);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(0,0,0,0.35);
  font-size: 1.1rem;
}

.zoom-arrow:hover {
  background: #713083;
  transform: translateY(-50%) scale(1.15);
}

.zoom-arrow-left {
  left: 20px;
}

.zoom-arrow-right {
  right: 20px;
}

.zoom-thumb-item {
  width: 70px;
  height: 70px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #ddd;
  transition: all 0.2s ease;
  background: white;
}

.zoom-thumb-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.zoom-thumb-item.selected-thumb {
  border-color: #713083;
  transform: scale(1.08);
  box-shadow: 0 4px 12px rgba(113, 48, 131, 0.35);
}
</style>
